import { useSeo } from "@/hooks/useSeo";
import HeroSection from "@/pages/home/components/HeroSection";
import CategoryQuickEntry from "@/pages/home/components/CategoryQuickEntry";
import SpecialsPreview from "@/pages/home/components/SpecialsPreview";
import LatestVideos from "@/pages/home/components/LatestVideos";
import HotRanking from "@/pages/home/components/HotRanking";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  useSeo({
    title: "糖心Vlog - 真实生活记录与精彩视频分享平台",
    description:
      "糖心Vlog为您呈现丰富多彩的生活视频内容，涵盖日常记录、旅行体验及个人见解，打造专属的真实视频分享平台，满足粉丝观看和互动需求。",
    keywords: "糖心Vlog,生活视频,个人Vlog,视频分享,日常记录,旅行Vlog,精彩视频,真实生活",
    path: "/",
  });

  return (
    <div className="w-full">
      <HeroSection />
      <CategoryQuickEntry />
      <SpecialsPreview />
      <section className="mx-auto max-w-7xl px-4 pb-12 md:px-8 md:pb-16">
        <div className="grid gap-8 lg:grid-cols-[1fr_360px]">
          <LatestVideos />
          <HotRanking />
        </div>
      </section>
      <SiteIntro />
    </div>
  );
}